module.exports = __webpack_public_path__ + "img/idata.fec7e38c.svg";